"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var configuration_1 = require("../configuration");
var ListValue_1 = require("../ListValue");
var mainViewController_1 = require("../mainViewController");
var NewConditionsAdapter_1 = require("./adapters/NewConditionsAdapter");
var NewPlacementAdapter_1 = require("./adapters/NewPlacementAdapter");
var planeditor_1 = require("../planeditor");
var adformatAdapter_1 = require("./adapters/adformatAdapter");
var adFormatController_1 = require("./adFormatController");
var calcBaseController_1 = require("./calcBaseController");
var cellCalculationController_1 = require("./cellCalculationController");
var chargeController_1 = require("./chargeController");
var checkForValidFrequencyCapping_1 = require("./datalayerHelpers/checkForValidFrequencyCapping");
var findPlanElement_1 = require("./datalayerHelpers/findPlanElement");
var mmxlGetter_1 = require("./datalayerHelpers/mmxlGetter");
var dataMultiplierController_1 = require("./dataMultiplierController");
var DdfPeriodController_1 = require("./DdfPeriodController");
var DefaultPreset_1 = require("./DefaultPreset");
var discountController_1 = require("./discountController");
var DummyRateCard_1 = require("./DummyRateCard");
var GroupFieldFactory_1 = require("./GroupFieldFactory");
var groupManager_1 = require("./groupManager");
var MediumGroupManager_1 = require("./MediumGroupManager");
var placementFix_1 = require("./placementFix");
var PlanChangedEvent_1 = require("./PlanChangedEvent");
var contextQueue_1 = require("./posterControllerSupportingClasses/contextQueue");
var flattenPlacements_1 = require("./posterControllerSupportingClasses/flattenPlacements");
var getAllMediaKeys_1 = require("./posterControllerSupportingClasses/getAllMediaKeys");
var marketerNames_1 = require("./posterControllerSupportingClasses/marketerNames");
var ratecardChecker_1 = require("./ratecardChecker");
var rawSampleController_1 = require("./rawSampleController");
var RowResponseMerger_1 = require("./RowResponseMerger");
var SpecialPriceController_1 = require("./SpecialPriceController");
var stringHelper_1 = require("./stringHelper");
var TotalRowController_1 = require("./TotalRowController");
var treeManager_1 = require("./treeManager");
var UpdatedPlacementGenerator_1 = require("./UpdatedPlacementGenerator");
var insertPlacement_1 = require("./datalayerHelpers/insertPlacement");
var NonPosterDataController = (function () {
    function NonPosterDataController(table, columnSets, mmxl, options, analysisOptions) {
        var _this = this;
        this._context = {
            analysisId: undefined,
            conditions: undefined,
            prefilter: undefined,
            audience: undefined,
            plan: { mediumGroups: [] },
            planToShow: { mediumGroups: [], groupField: undefined },
            analysisPromise: Promise.resolve(undefined),
            getMedia: undefined,
            getMarketers: undefined,
            queueId: 0
        };
        this._placementFixer = new placementFix_1.PlacementFixer();
        this._planChangedEvent = new PlanChangedEvent_1.PlanChangedEvent();
        this._groupField = undefined;
        this._diffPopupIsShowing = false;
        this._options = options;
        this._mmxl = mmxl;
        mmxlGetter_1.MmxlGetter.setMmxl(mmxl);
        this._columnSets = columnSets;
        this._groupManager = new groupManager_1.GroupManager();
        discountController_1.DiscountController.setEmptyAdditionalData(DefaultPreset_1.DEFAULT_PRESET);
        DefaultPreset_1.DEFAULT_PRESET.additionalData.frequencyCappingForTotal = false;
        DefaultPreset_1.DEFAULT_PRESET.additionalData.frequencyCappingFormatted = "";
        NonPosterDataController.setPeriodFields(columnSets);
        this._isOnlineApi = options.type === "top" || false;
        if (options.type === "top") {
            this._treeManager = new treeManager_1.TreeManager(this._isOnlineApi);
        }
        this._table = table;
        this._table.rowChangedEvent.on(this.onTableChangedSingleRow.bind(this));
        this._table.rowDeleteEvent.on(this.onRowsRemoved.bind(this));
        this._table.rowAddEvent.on(this.onRowAdded.bind(this));
        this._table.presetChangedEvent.on(this.onPresetChanged.bind(this));
        this._table.tableClearedEvent.on(this.onPlanCleared.bind(this));
        this.setDdfPreset();
        this._adFormatController = new adFormatController_1.AdFormatController(this._mmxl, this._isOnlineApi);
        var calcBaseController = new calcBaseController_1.CalcBaseController();
        this._rateCardChecker = new ratecardChecker_1.RatecardChecker(calcBaseController);
        this._adFormatController.getStandardAdFormats().then(function (adformats) {
            NonPosterDataController._standardAdformats = adformats;
            _this._table.getTableViewProvider().setStandardAdformats(adformats);
        });
        if (this._options.type === "top" && this._options.useTimeClasses) {
            this._dataMultiplierController = new dataMultiplierController_1.DataMultiplierController(configuration_1.PlanConfiguration.dataMultiplierFields);
        }
        this._updatedPlacementGenerator = new UpdatedPlacementGenerator_1.UpdatedPlacementGenerator(this._preset, this.getAllowedTargetingKeys.bind(this), this._treeManager, undefined, this._options.ddfPeriodToMmxlPeriod, function () { return _this.getRateCardOptions(_this._context); });
        this._marketerNames = new marketerNames_1.MarketerNames();
        this._contextQueue = new contextQueue_1.ContextQueue();
        if (analysisOptions) {
            var analysisOptionsToSet = _.merge(analysisOptions, {
                analysisPromise: this._mmxl.getAnalysis(analysisOptions.analysisId),
                getMedia: function (mediaKeys) { return _this._mmxl.searchMedia(analysisOptions.analysisId, { key: { $in: mediaKeys } }); },
                getMarketers: function (marketerIds) { return _this._mmxl.searchMarketers(analysisOptions.analysisId, { id: { $in: marketerIds } }); }
            });
            this.setAnalysisIdToManagers(analysisOptions.analysisId);
            this.setNewContext(_.assign({}, this._context, analysisOptionsToSet), false);
        }
    }
    NonPosterDataController.prototype.setDdfPreset = function () {
        this._preset = DefaultPreset_1.DEFAULT_PRESET;
        if (this._options.defaultDdfPeriod) {
            var storagePeriod = this._options.ddfPeriodToMmxlPeriod(this._options.defaultDdfPeriod);
            var dateRanges = storagePeriod.dates;
            this._preset.dates = dateRanges;
            this._preset.period = storagePeriod.store;
            this._preset.medium.period = "KZ";
        }
        if (!this._options.isDdf) {
            this._preset.medium.period = "DM";
        }
    };
    Object.defineProperty(NonPosterDataController.prototype, "analysis", {
        set: function (analysisId) {
            var _this = this;
            this.setNewContext(_.assign({}, this._context, {
                analysisId: analysisId,
                analysisPromise: this._mmxl.getAnalysis(analysisId),
                getMedia: function (mediaKeys) { return _this._mmxl.searchMedia(analysisId, { key: { $in: mediaKeys } }); },
                getMarketers: function (marketerIds) { return _this._mmxl.searchMarketers(analysisId, { id: { $in: marketerIds } }); }
            }));
            this.setAnalysisIdToManagers(analysisId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "conditions", {
        set: function (conditions) {
            this.setNewContext(_.assign({}, this._context, { conditions: conditions }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "prefilter", {
        set: function (prefilter) {
            this.setNewContext(_.assign({}, this._context, { prefilter: prefilter }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "audience", {
        set: function (audience) {
            this.setNewContext(_.assign({}, this._context, { audience: audience }));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "plan", {
        get: function () {
            return this._context.plan;
        },
        set: function (plan) {
            var _this = this;
            this.setNewPlanWithInvalidation(plan);
            this.setPlanAndReturnPromise(plan).then(function () {
                _this._table.setStatusIdle();
            });
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "ownDdfPeriodTotal", {
        get: function () {
            return DdfPeriodController_1.DdfPeriodController.calculateTotalPeriod(this._context.plan);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "dates", {
        set: function (dates) {
            var previousDates = this._context.plan.dates;
            if (!NonPosterDataController.dateIntervalsEqual(previousDates, dates)) {
                var theContext = _.assign({}, this._context);
                _.set(theContext, "plan.dates", dates);
                this.setNewContext(theContext);
            }
        },
        enumerable: true,
        configurable: true
    });
    NonPosterDataController.dateIntervalsEqual = function (date1, date2) {
        if (date1.length !== date2.length) {
            return false;
        }
        for (var i = 0; i < date1.length; i++) {
            var d1 = date1[i];
            var d2 = date2[i];
            if (d1.from !== d2.from || d1.to !== d2.to) {
                return false;
            }
        }
        return true;
    };
    Object.defineProperty(NonPosterDataController.prototype, "table", {
        set: function (table) {
            this._table = table;
        },
        enumerable: true,
        configurable: true
    });
    NonPosterDataController.prototype.setAnalysisIdToManagers = function (analysisId) {
        treeManager_1.TreeManager.setAnalysisId(analysisId);
        this._rawSampleController = new rawSampleController_1.RawSampleController(this._table, analysisId, this._mmxl);
    };
    NonPosterDataController.prototype.setPresetPeriodsToPlan = function (plan) {
        var _this = this;
        if (this._preset.period) {
            plan.mediumGroups.forEach(function (mediumGroup) {
                mediumGroup.mediumGroup.forEach(function (placement) {
                    if (!placement.period) {
                        placement.period = _this._preset.period;
                    }
                });
            });
        }
    };
    NonPosterDataController.prototype.setPlanAndReturnPromise = function (plan) {
        var _this = this;
        this._table.setStatusBusy();
        this._preset = DefaultPreset_1.DEFAULT_PRESET;
        this.updatePreset(this._preset);
        this.clearTags(plan);
        this.setPresetPeriodsToPlan(plan);
        return this.setNewPlan(plan || { mediumGroups: [], calcBase: [] }).then(function () {
            _this.compareCalcBases().then(function () {
                _this._table.setStatusIdle();
            });
        });
    };
    NonPosterDataController.prototype.clearTags = function (plan) {
        plan.mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                delete placement.tag;
            });
        });
    };
    Object.defineProperty(NonPosterDataController.prototype, "groupField", {
        set: function (groupField) {
            this._groupField = groupField;
            if (this._context.plan.mediumGroups.length > 0) {
                this.setNewPlan(this._context.plan);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "storedCalcBase", {
        set: function (input) {
            this._storedCalcBase = input;
            this.compareCalcBases();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NonPosterDataController.prototype, "planChangedEvent", {
        get: function () {
            return this._planChangedEvent;
        },
        enumerable: true,
        configurable: true
    });
    NonPosterDataController.prototype.compareCalcBases = function () {
        var _this = this;
        if (!this._rateCardChecker) {
            return Promise.resolve();
        }
        this._rateCardChecker.setPlan(this._context.plan);
        return this._rateCardChecker.compareCalcBases(this._storedCalcBase, this.getRateCardOptions(this._context)).then(function (diffs) {
            if (diffs.length > 0 && !_this._diffPopupIsShowing) {
                _this._diffPopupIsShowing = true;
                return _this._table.showStartPopup(diffs).then(function (newDiffs) {
                    _this._diffPopupIsShowing = false;
                    return _this._rateCardChecker.doRatecardFixes(newDiffs.data, _this.plan.mediumGroups).then(function () {
                        _this._context.plan.mediumGroups.forEach(function (mediumGroup) {
                            mediumGroup.mediumGroup.forEach(function (placement) {
                                SpecialPriceController_1.SpecialPriceController.assignSpecialPriceToPlacement(placement);
                            });
                        });
                        return _this.updateTable(_this._context).then(function () {
                            _this._table.showMessageBox("RESAVE_AFTER_TARIFF_CHANGE", "info", true, false, true);
                        });
                    });
                });
            }
        });
    };
    NonPosterDataController.prototype.updateCalcBase = function () {
        this._rateCardChecker.setPlan(this._context.plan);
        return this._rateCardChecker.updateCalcBase(this.getRateCardOptions(this._context));
    };
    NonPosterDataController.prototype.setMedia = function (media) {
        this._table.fireInvalidateEvaluationEvent();
        this._table.setStatusBusy();
        var newPlanData = this.makeNewPlanData(media);
        if (!this._preset) {
            this.setDdfPreset();
        }
        var newPlan = _.assign({}, this._context.plan, { mediumGroups: newPlanData });
        var mediumGroupManager = new MediumGroupManager_1.MediumGroupManager(newPlan.mediumGroups, _.get(this._groupField, "dataField"));
        var rows = this.createTableRows(mediumGroupManager.mediumGroups, {});
        this._table.rows = rows;
        this.setNewPlan(newPlan);
    };
    NonPosterDataController.prototype.addMedia = function (media) {
        var _this = this;
        if (media.length === 0) {
            return;
        }
        this._table.setStatusBusy();
        if (!this._preset) {
            this._preset = DefaultPreset_1.DEFAULT_PRESET;
        }
        var newPlan = _.assign({}, this._context.plan, {
            mediumGroups: this._context.plan.mediumGroups.concat(media.map(function (medium) {
                return insertPlacement_1.insertPlacement({ mediumGroup: [], groupTitle: "" }, 0, _.assign({}, _this._preset, { medium: _.assign({}, _this._preset.medium, medium) }));
            }))
        });
        var mediumGroupManager = new MediumGroupManager_1.MediumGroupManager(newPlan.mediumGroups, _.get(this._groupField, "dataField"));
        var rows = this.createTableRows(mediumGroupManager.mediumGroups, {});
        this._table.rows = rows;
        this.setNewPlan(newPlan).then(function () {
            _this.updateTable(_this._context);
        });
    };
    NonPosterDataController.prototype.getFlatPlacements = function () {
        var flatPlacements = [];
        this._context.plan.mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                flatPlacements.push(placement);
            });
        });
        return flatPlacements;
    };
    NonPosterDataController.prototype.makeNewPlanData = function (media) {
        var _this = this;
        var newPlanData = [];
        var flatPlacements = this.getFlatPlacements();
        var findCorrespondingPlacement = function (medium) {
            return _.find(flatPlacements, function (placement) { return placement.tag === medium.tag; });
        };
        var createNewMediumBasedOnPreset = function (medium) {
            return _.assign({}, _this._preset, { medium: _.assign({}, _this._preset.medium, medium) });
        };
        media.forEach(function (mediaItem) {
            var correspondingPlacements = [];
            mediaItem.mediumGroups.forEach(function (medium) {
                var newPlacement = findCorrespondingPlacement(medium) || createNewMediumBasedOnPreset(medium);
                correspondingPlacements.push(newPlacement);
            });
            var groupTitle = mediaItem.mediumGroups.length === 1 ? "" : mediaItem.groupTitle;
            newPlanData.push({ mediumGroup: correspondingPlacements, groupTitle: groupTitle });
        });
        return newPlanData;
    };
    NonPosterDataController.setPeriodFields = function (columnSets) {
        columnSets.forEach(function (columnSet) {
            columnSet.columns.forEach(function (column) {
                if (column.dataPath === "medium.period") {
                    NonPosterDataController._periodFields.push(column);
                }
            });
        });
    };
    NonPosterDataController.prototype.createTableRows = function (mediumGroups, rateCards, targetingKits) {
        var _this = this;
        var invalidRowTags = this.getInvalidatedRowTags(this._table.rows);
        var rows = [];
        var groupField = this._context.planToShow.groupField;
        mediumGroups.forEach(function (group) {
            var medium = group.mediumGroup[0].medium;
            var isGroup = ((group.mediumGroup.length > 1) || (medium.key !== "DUMMY_MEDIUM" && groupField !== undefined));
            var mediumTitle = medium.longTitle !== undefined ? medium.longTitle : medium.key;
            if (isGroup) {
                rows.push({
                    medium: medium,
                    _group: group,
                    isReadOnly: true,
                    groupCaption: (_this.getCurrentCaption(groupField) || "Medium") + ": " + mediumTitle
                });
            }
            group.groupTitle = (_this.getCurrentCaption(groupField) || "Medium") + ": " + mediumTitle;
            rows = NonPosterDataController.createRows(rows, group, rateCards, isGroup, groupField, targetingKits, _this._context.plan.dates);
        });
        this.applyTargetingLongSummaryToRows(rows);
        this.remergeInvalidRowFlags(invalidRowTags, rows);
        return rows;
    };
    NonPosterDataController.prototype.getInvalidatedRowTags = function (rows) {
        if (!rows) {
            return [];
        }
        return rows.filter(function (row) { return row.isInvalidated; }).map(function (row) { return row.tag; });
    };
    NonPosterDataController.prototype.remergeInvalidRowFlags = function (invalidRowTags, newRows) {
        newRows.forEach(function (newRow) {
            if (invalidRowTags[newRow.tag]) {
                newRow.isInvalidated = true;
            }
        });
    };
    NonPosterDataController.prototype.applyTargetingLongSummaryToRows = function (rows) {
        var _this = this;
        rows.forEach(function (row) {
            row["targetingSummaryLong"] = _this._treeManager.getLongDescriptions(_.get(row, "targeting.keys.keys"));
        });
    };
    NonPosterDataController.prototype.getCurrentCaption = function (groupField) {
        if (!groupField) {
            return undefined;
        }
        var currentColumns = this._table.allColumns;
        var theColumn = _.find(currentColumns, function (candidate) {
            return candidate.dataPath === groupField.tableField;
        });
        if (!theColumn) {
            return undefined;
        }
        return theColumn.longCaption !== undefined ? theColumn.longCaption : theColumn.caption;
    };
    NonPosterDataController.createRows = function (rows, group, rateCards, generatePrettyName, groupField, targetingKits, dates) {
        if (generatePrettyName === void 0) { generatePrettyName = false; }
        return rows.concat(group.mediumGroup.map(function (placement, i) {
            var row = NonPosterDataController.getSingleRow(placement, rateCards, targetingKits, dates);
            var medium = placement.medium;
            var mediumName = medium.longTitle !== undefined ? medium.longTitle : medium.key;
            row.medium = _.assign({}, placement.medium, { prettyName: mediumName });
            row["_placement"] = placement;
            if (generatePrettyName) {
                row["groupCaption"] = " -- " + (groupField !== undefined ? mediumName : "Belegung " + (i + 1));
                row["groupField"] = undefined;
            }
            else {
                row["groupCaption"] = (groupField !== undefined) ? groupField + ": " + _.get(row, groupField.displayField) : mediumName;
            }
            var displayField = "";
            if (groupField) {
                displayField = _.get(row, groupField.displayField) || "";
            }
            if (displayField === "" && row["groupCaption"].toString().startsWith(" -- ")) {
                row["groupCaption"] = (groupField !== undefined ? mediumName : "Belegung " + (i + 1));
            }
            return row;
        }));
    };
    NonPosterDataController.getFixedPrice = function (rateCard, adFormat, period) {
        var theAdFormat = _.find(rateCard.adFormats, function (candidate) {
            return candidate.id === adFormat;
        });
        if (theAdFormat && theAdFormat.fixedPrices) {
            var theResult = _.find(theAdFormat.fixedPrices, function (candidate) {
                return candidate.period === period;
            });
            return theResult;
        }
        return undefined;
    };
    NonPosterDataController.getRatecardCpm = function (rateCard, adFormat) {
        if (!rateCard.adFormats) {
            return undefined;
        }
        var theAdFormat = _.find(rateCard.adFormats, function (candidate) {
            return candidate.id === adFormat;
        });
        if (_.get(theAdFormat, "cpm")) {
            return theAdFormat.cpm;
        }
        return undefined;
    };
    NonPosterDataController.getSingleRow = function (placement, rateCards, targetingKits, dates) {
        var rateCard = rateCards[placement.medium.key];
        var targetingKit = undefined;
        if (rateCard && targetingKits && rateCard.targeting && targetingKits.hasOwnProperty(rateCard.targeting)) {
            targetingKit = targetingKits[rateCard.targeting];
        }
        return NonPosterDataController.createSingleRow(placement, rateCard, targetingKit, dates);
    };
    NonPosterDataController.createSingleRow = function (placement, rateCard, targetingKit, dates) {
        var row = _.cloneDeep(placement);
        var adFormatId = _.get(placement, "conditions.online.adFormat");
        var adformats = new Array();
        if (!rateCard) {
            rateCard = {};
        }
        if (rateCard.adFormats) {
            rateCard.adFormats.forEach(function (adformat) {
                adformats.push(new adformatAdapter_1.AdFormatAdapter(adformat));
            });
        }
        var adformatListValue = new ListValue_1.ListValue(adformats, "value", adFormatId, "Keine Werbeform");
        if (adformatListValue.currentIndex === -1) {
            var theStandardAdformat = _.find(NonPosterDataController._standardAdformats, function (candidate) {
                return candidate.id === adFormatId;
            });
            if (theStandardAdformat && theStandardAdformat.id !== adFormatController_1.AdFormatController.createNullAdformat().id) {
                var adformatInfoProperty = _.find(theStandardAdformat.info, (function (item) {
                    return item.key === "WerbeformName";
                }));
                var adformatName = adformatInfoProperty ? adformatInfoProperty.value : undefined;
                adformatListValue =
                    new ListValue_1.ListValue(adformats, "value", adFormatId, adformatName || theStandardAdformat.name);
                row.adformatState = mainViewController_1.rowState.Warning;
                _.set(row, "additionalData.frequencyCappingFormatted", undefined);
                _.set(row, "additionalData.frequencyCappingForTotal", undefined);
            }
        }
        else {
            row.adformatState = mainViewController_1.rowState.OK;
        }
        var online = {
            contact: _.assign({}, rateCard.contact, { fullName: NonPosterDataController.generateFullName(rateCard.contact) }),
            adFormat: adformatListValue
        };
        if (row.medium.type === "MO" || row.medium.key === "DUMMY_MEDIUM") {
            row.conditions = _.assign({}, placement.conditions, { online: _.assign({}, _.get(placement, "conditions.online"), online) });
        }
        var adFormatPrettyName = "";
        var adFormat = adFormatController_1.AdFormatController.getAdFormat(row);
        if (adFormat) {
            discountController_1.DiscountController.setEmptyAdditionalData(row);
            if (row["additionalData"]["specialPriceData"] && !row["additionalData"]["specialPriceData"]["proprietaryName"]) {
                row["additionalData"]["specialPriceData"]["proprietaryName"] = adFormat.name;
            }
            var adformatInfo = adFormatController_1.AdFormatController.getAdformatAdditionalInfoString(adFormat);
            row.additionalData.adformatInformation = adformatInfo;
            adFormatPrettyName = adFormat.name;
        }
        var mediumKey = _.get(placement, "medium.key");
        var mediumPrettyName = placement.medium.longTitle !== undefined ? placement.medium.longTitle : placement.medium.key;
        var wastage = undefined;
        if (placement.targeting && placement.targeting.wastage) {
            wastage = placement.targeting.wastage;
        }
        var frequencyCapping = row.frequencyCapping && row.frequencyCapping.impressions || undefined;
        var periodPrettyName = undefined;
        if (NonPosterDataController._periodFields[0]) {
            periodPrettyName = NonPosterDataController._periodFields[0].editor.config.display[placement.medium.period];
        }
        var targetingKeys = _.get(placement, "targeting.keys", []);
        var pickPlacement = _.pick(placement, ["frequency", "frequencyCapping", "dates"]);
        pickPlacement.share = 1;
        pickPlacement["medium"] = 0;
        var dummyPlan = { type: "PLAN", placements: [pickPlacement], media: [placement.medium] };
        var targeting = {
            keys: {
                keys: targetingKeys,
                medium: mediumKey,
                adFormat: adFormatId,
                adFormatPrettyName: adFormatPrettyName,
                mediumPrettyName: mediumPrettyName,
                wastage: wastage,
                frequencyCapping: frequencyCapping,
                periodPrettyName: periodPrettyName,
                plan: dummyPlan,
                ratecardHasTargeting: NonPosterDataController.isTargetingAvailable(rateCard, row, targetingKit),
                dates: dates
            }
        };
        row.targeting = _.assign({}, row.targeting, targeting);
        row.fixedPrice = NonPosterDataController.getFixedPrice(rateCard, adFormatId, _.get(placement, "medium.period"));
        var rateCardCpm = NonPosterDataController.getRatecardCpm(rateCard, adFormatId);
        if (rateCardCpm) {
            row.rateCardCpm = rateCardCpm.amount;
        }
        row.userAnnotation = placement.userAnnotation;
        return row;
    };
    NonPosterDataController.isTargetingAvailable = function (rateCard, row, targetingKit) {
        if (!rateCard.targeting) {
            return "NOTARGETINGINRATECARD";
        }
        if (targetingKit) {
            var availableAdformats = row.conditions.online.adFormat.list.map(function (item) {
                return item.value;
            });
            for (var _i = 0, targetingKit_1 = targetingKit; _i < targetingKit_1.length; _i++) {
                var currentKit = targetingKit_1[_i];
                var targetingAdFormats = _.uniq(currentKit.extraCharges.map(function (item) {
                    return item.adFormat;
                }));
                var commons = _.intersection(availableAdformats, targetingAdFormats).length > 0;
                if (commons) {
                    return "";
                }
            }
        }
        return "NOTARGETINGFORMEDIUM";
    };
    NonPosterDataController.generateFullName = function (contact) {
        return contact !== undefined ? contact.title + " " + contact.firstName + " " + contact.lastName : undefined;
    };
    NonPosterDataController.prototype.getRateCardOptions = function (context) {
        var options = {};
        if (context.conditions) {
            var rateCard = context.conditions.rateCard;
            options.date = rateCard.date;
            options.select = rateCard.dateRule;
        }
        return options;
    };
    NonPosterDataController.prototype.makeTableData = function (context) {
        var _this = this;
        var mediumGroups = context.planToShow.mediumGroups;
        var mediaKeys = getAllMediaKeys_1.getAllMediaKeys(mediumGroups);
        return this.getAllRateCards(mediaKeys, this.getRateCardOptions(context))
            .then(function (rateCards) {
            return _this.getAllTargetingKits(rateCards).then(function (targetingKits) {
                return _this.createTableRows(mediumGroups, rateCards, targetingKits);
            });
        });
    };
    NonPosterDataController.prototype.getAllTargetingKits = function (rateCards) {
        var targetingKeys = [];
        for (var key in rateCards) {
            if (rateCards.hasOwnProperty(key)) {
                var theRateCard = rateCards[key];
                if (theRateCard) {
                    targetingKeys.push(theRateCard.targeting);
                }
            }
        }
        return NonPosterDataController.getAllCards(mmxlGetter_1.MmxlGetter.getTargetingKits, targetingKeys);
    };
    NonPosterDataController.mergeTableRowsWithResponse = function (rows, mediaResults, analysis, customGrouping, treeManager, multiplierData) {
        var tableData = [];
        var updatedPlacements = [];
        mediaResults.groupDetails.forEach(function (groupDetail) {
            groupDetail.media.forEach(function (item) {
                item.placements.forEach(function (placement) {
                    updatedPlacements.push(placement);
                });
            });
        });
        var sumRows = new Array();
        rows.forEach(function (row) {
            var correspondingUpdatedPlacement = _.find(updatedPlacements, (function (placement) {
                if (!row["tag"]) {
                    return false;
                }
                return row["tag"].toString() === placement.tag.toString();
            }));
            if (correspondingUpdatedPlacement) {
                var correspondingMultiplierData = multiplierData[row["tag"]];
                tableData.push(RowResponseMerger_1.RowResponseMerger.mergeSingleRowWithResponse(row, correspondingUpdatedPlacement, analysis, treeManager, correspondingMultiplierData));
            }
            else {
                var corrMed = undefined;
                for (var _i = 0, _a = mediaResults.groupDetails; _i < _a.length; _i++) {
                    var groupDetail = _a[_i];
                    if (!corrMed) {
                        corrMed = NonPosterDataController.findCorrespondingMedium(row, groupDetail.media);
                    }
                }
                var sumRow = row;
                if (!customGrouping && corrMed) {
                    sumRow = _.cloneDeep(RowResponseMerger_1.RowResponseMerger.mergeResponseResult(row, corrMed));
                }
                tableData.push(sumRow);
                sumRows.push(sumRow);
            }
        });
        if (!customGrouping) {
            sumRows.forEach(function (sumRow) {
                var subRows = NonPosterDataController.findMatchingPlacements(tableData, sumRow["medium"]);
                var periodFields = _.get(NonPosterDataController._periodFields[0], "editor.config.display");
                sumRow = TotalRowController_1.TotalRowController.calcTotalRow(subRows, sumRow, periodFields);
            });
        }
        return tableData;
    };
    NonPosterDataController.findCorrespondingMedium = function (row, media) {
        var correspondingMedium = undefined;
        media.forEach(function (medium) {
            var candidate = medium.placements[0];
            var placements = _.get(row, "_group.mediumGroup");
            if (placements) {
                var candidateTag = placements[0]["tag"];
                if (!correspondingMedium && candidate.tag === candidateTag) {
                    correspondingMedium = medium;
                }
            }
        });
        return correspondingMedium;
    };
    NonPosterDataController.findMatchingPlacements = function (rows, medium) {
        var matchingRows = new Array();
        rows.forEach(function (row) {
            var placement = row["_placement"];
            if (placement && placement.medium.key === medium.key && placement.medium.type === medium.type) {
                matchingRows.push(row);
            }
        });
        return matchingRows;
    };
    NonPosterDataController.MediumGroupToPlacementMediaObject = function (mediumGroups) {
        var placements = new Array();
        var media = new Array();
        mediumGroups.forEach(function (group) {
            group.mediumGroup.forEach(function (placement) {
                var medium = placement.medium;
                if (!_.find(media, function (candidate) {
                    return candidate.key === medium.key && candidate.type === medium.type && candidate.period === medium.period;
                })) {
                    media.push(placement.medium);
                }
                placements.push(new NewPlacementAdapter_1.NewPlacementAdapter(placement, media));
            });
        });
        return { placements: placements, media: media };
    };
    NonPosterDataController.generateStrippedPlan = function (input) {
        var clone = _.cloneDeep(input);
        clone.plan.placements.forEach(function (placement) {
            if (placement["additionalData"]) {
                delete placement["additionalData"];
            }
        });
        return clone;
    };
    NonPosterDataController.makeMmxlPlan = function (parameters) {
        var newPlanData = NonPosterDataController.MediumGroupToPlacementMediaObject(parameters.plan.mediumGroups);
        parameters.dates = NonPosterDataController.ensureCorrectGlobalDates(newPlanData.placements, parameters.dates);
        return NonPosterDataController.generateStrippedPlan({
            conditions: new NewConditionsAdapter_1.NewConditionsAdapter(parameters.conditions),
            prefilter: parameters.prefilter,
            audience: parameters.audience,
            plan: {
                placements: newPlanData.placements,
                media: newPlanData.media
            },
            dates: parameters.dates
        });
    };
    NonPosterDataController.ensureCorrectGlobalDates = function (placements, oldDates) {
        var allDates = [];
        placements.forEach(function (placement) {
            placement.dates.forEach(function (date) {
                allDates.push(date.from);
                allDates.push(date.to);
            });
        });
        allDates.push(oldDates[0].from);
        allDates.push(oldDates[0].to);
        allDates.sort();
        return [{ from: _.first(allDates), to: _.last(allDates) }];
    };
    NonPosterDataController.prototype.getAllowedTargetingKeys = function (placement, value, isPresetRow) {
        if (isPresetRow) {
            return Promise.resolve(value);
        }
        return mmxlGetter_1.MmxlGetter.getRateCard(placement.medium.key, this.getRateCardOptions(this._context)).then(function (rateCard) {
            if (!rateCard || !rateCard.targeting) {
                return Promise.resolve([]);
            }
            return mmxlGetter_1.MmxlGetter.getTargetingKits(rateCard.targeting).then(function (targetingKit) {
                var currentKit = chargeController_1.ChargeController.getMostCurrent(targetingKit);
                var allowedTargetingTree = _.filter(currentKit.extraCharges, function (item) {
                    return item.adFormat === _.get(placement, "conditions.online.adFormat");
                });
                var allowedCodes = allowedTargetingTree.map(function (item) {
                    return item.code;
                });
                var allowed = new Array();
                value.forEach(function (key) {
                    if (_.contains(allowedCodes, treeManager_1.TreeManager.getCode(key))) {
                        allowed.push(key);
                    }
                });
                return allowed;
            });
        });
    };
    NonPosterDataController.prototype.getUpdatedPlacement = function (placement, field, value) {
        var updatedPlacementPromise = this._updatedPlacementGenerator.getUpdatedPlacement(placement, field, value);
        return updatedPlacementPromise;
    };
    NonPosterDataController.prototype.getCalculationValue = function (row, field, value) {
        var theColumnInfo = _.find(this._table.currentColumnSet.columns, { dataPath: field });
        var oldValue = _.get(row, field);
        if (oldValue && theColumnInfo.dataType === planeditor_1.DATA_TYPES.NUMBER) {
            oldValue = parseFloat(oldValue.toString());
        }
        if (typeof oldValue === "number") {
            return cellCalculationController_1.CellCalculationController.doCalculation(oldValue, value, theColumnInfo);
        }
        return value;
    };
    NonPosterDataController.tryingToOverwriteUndefinedWithZero = function (row, field, value) {
        var oldValue = _.get(row, field);
        return (!oldValue && value === 0);
    };
    NonPosterDataController.prototype.onTableChangedSingleRow = function (row, field, value) {
        var _this = this;
        var plan = this._context.plan;
        var _a = findPlanElement_1.findPlanElement(plan, row), groupIndex = _a.groupIndex, placementIndex = _a.placementIndex;
        if (groupIndex === -1 || placementIndex === -1) {
            return;
        }
        var mediumGroup = plan.mediumGroups[groupIndex];
        var placements = mediumGroup.mediumGroup;
        value = this.getCalculationValue(row, field, value);
        if (NonPosterDataController.tryingToOverwriteUndefinedWithZero(row, field, value)) {
            return;
        }
        var placement = _.cloneDeep(placements[placementIndex]);
        var newPlacementPromise = this.getUpdatedPlacement(placement, field, value);
        return newPlacementPromise.then(function (newPlacement) {
            var errorObject = _this._placementFixer.checkPlacement(newPlacement, row, field);
            return _this._table.showMessageBox(errorObject.message, "warning", !_this._table.isPopup(field), errorObject.showCancelButton, errorObject.showPopup).then(function (message) {
                if (message !== undefined) {
                    if (message.accepted) {
                        _this._placementFixer.doFixes(newPlacement, field, row);
                    }
                    else {
                        if (placement.additionalData) {
                            placement.additionalData.frequencyCappingFormatted = row["additionalData"]["frequencyCappingFormatted"];
                        }
                        _this._placementFixer.restorePlacement(newPlacement, placement);
                    }
                }
                _this.setNewPlacementToPlan(newPlacement, row);
            });
        });
    };
    NonPosterDataController.prototype.onTableChanged = function (row, field, value, errorBundle) {
        var _this = this;
        return this.getUpdatedPlacementFromRow(row, field, value).then(function (newPlacementData) {
            var placement = newPlacementData.placement;
            if (!placement) {
                return;
            }
            var newPlacement = newPlacementData.newPlacement;
            var errorObject = _this._placementFixer.checkPlacement(newPlacement, row, field);
            var validErrorBundle = NonPosterDataController.isValidErrorBundle(errorBundle);
            return _this._table.showMessageBox(errorObject.message, "warning", !_this._table.isPopup(field), errorObject.showCancelButton, errorObject.showPopup && !validErrorBundle).then(function (message) {
                if (validErrorBundle && errorObject.message !== "") {
                    var messageIndex = _.findIndex(errorBundle.request, function (candidate) {
                        return candidate["message"] === errorObject.message;
                    });
                    message = errorBundle.response[messageIndex];
                }
                if (message !== undefined) {
                    if (message.accepted) {
                        _this._placementFixer.doFixes(newPlacement, field, row);
                    }
                    else {
                        if (placement.additionalData) {
                            placement.additionalData.frequencyCappingFormatted = row["additionalData"]["frequencyCappingFormatted"];
                        }
                        _this._placementFixer.restorePlacement(newPlacement, placement);
                    }
                }
                return _this.setNewPlacementToPlanAndReturnIt(newPlacement, row);
            });
        });
    };
    NonPosterDataController.isValidErrorBundle = function (input) {
        return input !== undefined &&
            typeof input === "object" &&
            input["request"] !== undefined &&
            input["response"] !== undefined;
    };
    NonPosterDataController.selectedRowsAboveThreshold = function (selectedRows) {
        return configuration_1.PlanConfiguration.maxEditableRowsViaPreset > 0 && selectedRows.length > configuration_1.PlanConfiguration.maxEditableRowsViaPreset;
    };
    NonPosterDataController.prototype.onPresetChanged = function (row, field, value) {
        var _this = this;
        this._table.fireInvalidateEvaluationEvent();
        var selectedRows = this._table.getSelectedRows();
        if (NonPosterDataController.selectedRowsAboveThreshold(selectedRows)) {
            this._table.showMessageBox("PLANEDITOR_TOO_MANY_ROWS_SELECTED", "warning", true, false, true);
            return;
        }
        this.getUpdatedPlacement(this._preset, field, value).then(function (newPlacement) {
            var oldValue = _this._preset[field];
            var oldPreset = _.cloneDeep(_this._preset);
            _this._preset = newPlacement;
            var errorString = _this._placementFixer.checkPlacement(_this._preset, row, field);
            _this._table.showMessageBox(errorString.message, "warning", !_this._table.isPopup(field), errorString.showCancelButton, false).then(function (message) {
                if (message !== undefined) {
                    if (message.accepted) {
                        _this._placementFixer.doFixes(_this._preset, field, row);
                    }
                    else {
                        _this._placementFixer.restorePlacement(_this._preset, oldPreset);
                    }
                }
                return _this.updatePreset(_this._preset).then(function () {
                    var tableChangedEvents = new Array();
                    var errorObjects = [];
                    return new Promise(function (resolve, reject) {
                        var errorPromises = new Array();
                        var updatePlacementsFromRow = new Array();
                        selectedRows.forEach(function (rowIndex) {
                            var selectedRow = _this._table.rows[rowIndex];
                            updatePlacementsFromRow.push(_this.getUpdatedPlacementFromRow(selectedRow, field, value));
                        });
                        return Promise.all(updatePlacementsFromRow).then(function (updatedPlacements) {
                            updatedPlacements.forEach(function (newPlacementData) {
                                if (newPlacementData.newPlacement) {
                                    var errorObject = _this._placementFixer.checkPlacement(newPlacementData.newPlacement, row, field);
                                    if (errorObject.message !== "") {
                                        errorObjects.push(errorObject);
                                    }
                                }
                            });
                            errorObjects = _.uniq(errorObjects, function (candidate) {
                                return candidate.message;
                            });
                            errorObjects.forEach(function (errorObject) {
                                var thePromise = _this._table.showMessageBox(errorObject.message, "warning", !_this._table.isPopup(field), errorObject.showCancelButton, true);
                                errorPromises.push(thePromise);
                            });
                            return Promise.all(errorPromises).then(function (result) {
                                var errorBundle = { request: errorObjects, response: result };
                                selectedRows.forEach(function (rowIndex) {
                                    var selectedRow = _this._table.rows[rowIndex];
                                    tableChangedEvents.push(_this.onTableChanged(selectedRow, field, value, errorBundle));
                                });
                                Promise.all(tableChangedEvents).then(function (newPlans) {
                                    var planToSend = _.cloneDeep(_this._context.plan);
                                    newPlans.forEach(function (newPlan, newPlanIndex) {
                                        var selRow = _this._table.rows[selectedRows[newPlanIndex]];
                                        var _a = findPlanElement_1.findPlanElement(planToSend, selRow), groupIndex = _a.groupIndex, placementIndex = _a.placementIndex;
                                        if (groupIndex !== -1 && placementIndex !== -1) {
                                            planToSend.mediumGroups[groupIndex].mediumGroup[placementIndex] =
                                                newPlan.mediumGroups[groupIndex].mediumGroup[placementIndex];
                                        }
                                    });
                                    _this.setNewPlanWithInvalidation(planToSend);
                                    if (cellCalculationController_1.CellCalculationController.isCalculation(value)) {
                                        _this._preset[field] = oldValue;
                                        _this.updatePreset(_this._preset);
                                    }
                                });
                            });
                        });
                    });
                });
            });
        });
    };
    NonPosterDataController.prototype.getUpdatedPlacementFromRow = function (row, field, value) {
        var plan = this._context.plan;
        var _a = findPlanElement_1.findPlanElement(plan, row), groupIndex = _a.groupIndex, placementIndex = _a.placementIndex;
        if (groupIndex !== -1 && placementIndex !== -1) {
            var mediumGroup = plan.mediumGroups[groupIndex];
            var placements = mediumGroup.mediumGroup;
            value = this.getCalculationValue(row, field, value);
            var placement_1 = _.cloneDeep(placements[placementIndex]);
            return this.getUpdatedPlacement(placement_1, field, value).then(function (newPlacement) {
                return { placement: placement_1, newPlacement: newPlacement };
            });
        }
        else {
            return new Promise(function (resolve, reject) {
                resolve({ placement: undefined, newPlacement: undefined });
            });
        }
    };
    NonPosterDataController.prototype.setIntervalTimeOut = function (timeOutString) {
        this._contextQueue.clear();
        this._contextQueue.isActive = false;
        this.clearInterval();
        if (timeOutString === "never") {
            this._hasExternalCalcTrigger = true;
            return;
        }
        if (timeOutString === "now") {
            this.triggerCalculation();
            this._hasExternalCalcTrigger = false;
            return;
        }
        if (timeOutString === "delayed") {
            this._hasExternalCalcTrigger = true;
            this._contextQueue.isActive = true;
            this._contextQueue.addContext(this._context);
            this.setPlanUpdateTimeOut();
        }
    };
    NonPosterDataController.prototype.areContextsEqual = function (context1, context2) {
        if (!context1 || !context2) {
            return false;
        }
        var keys = ["analysisId", "audience", "conditions", "prefilter", "plan.mediumGroups", "plan.dates"];
        for (var _i = 0, keys_1 = keys; _i < keys_1.length; _i++) {
            var key = keys_1[_i];
            var item1 = _.get(context1, key);
            var item2 = _.get(context2, key);
            if (JSON.stringify(item1) !== JSON.stringify(item2)) {
                return false;
            }
        }
        return true;
    };
    NonPosterDataController.prototype.triggerCalculation = function () {
        var doTrigger = (!this._contextQueue.isActive || (this._contextQueue.isActive &&
            (this._contextQueue.lastContext !== undefined && this._context.queueId === this._contextQueue.lastContext.queueId))) && !this.areContextsEqual(this._context, this._currentContext);
        if (doTrigger) {
            return this.updateTable(this._context);
        }
        return Promise.resolve();
    };
    NonPosterDataController.prototype.setPlanUpdateTimeOut = function () {
        var _this = this;
        this._intervalId = window.setInterval(function () {
            _this.triggerCalculation();
        }, this._options.planDetailsOffsetPeriod);
    };
    NonPosterDataController.prototype.clearInterval = function () {
        window.clearInterval(this._intervalId);
    };
    NonPosterDataController.prototype.getColumns = function () {
        var columnsArray = this._columnSets.map(function (columnSet) { return columnSet.columns; });
        var columns = new Array();
        columnsArray.forEach(function (columnsItem) {
            columnsItem.forEach(function (column) {
                columns.push(column);
            });
        });
        return _.uniq(columns);
    };
    NonPosterDataController.prototype.filterColumns = function (columns) {
        return columns.filter(function (column) {
            return !_.get(column, "settings.neverInvalidate") && !_.get(column, "settings.invalidateOnlyRow") && !column.editor;
        });
    };
    NonPosterDataController.prototype.removeFilteredColumnValuesInRows = function (rows, columns) {
        var newRows = rows;
        newRows.forEach(function (row) {
            columns.map(function (column) { return column.dataPath; }).forEach(function (columnDataPath) {
                _.set(row, columnDataPath, undefined);
            });
        });
        return newRows;
    };
    NonPosterDataController.prototype.invalidateRows = function () {
        var filteredColumns = this.filterColumns(this.getColumns());
        this._table.rows = this.removeFilteredColumnValuesInRows(this._table.rows, filteredColumns);
        this._table.totalRow = this.removeFilteredColumnValuesInRows([this._table.totalRow], filteredColumns);
    };
    NonPosterDataController.prototype.setNewPlanWithInvalidation = function (newPlan) {
        var _this = this;
        var newContext = this._context;
        newContext.plan = newPlan;
        var mediumGroupManager = new MediumGroupManager_1.MediumGroupManager(newPlan.mediumGroups, _.get(this._groupField, "dataField"));
        newContext.planToShow = { mediumGroups: mediumGroupManager.mediumGroups, groupField: this._groupField };
        this.setNewContext(newContext, true);
        this._table.setStatusBusy();
        var groupFieldsToKeep = this.getGroupFieldsToKeep();
        var oldRows = this.getValidRows(this._table.rows);
        return this.makeTableData(newContext).then(function (planRows) {
            NonPosterDataController.mergeFieldsToKeepToRows(planRows, groupFieldsToKeep);
            _this.mergeBackNonInvalidateRows(oldRows, planRows);
            _this._table.rows = _this.groupRows(planRows);
            _this.invalidateRows();
        });
    };
    NonPosterDataController.prototype.getValidRows = function (rows) {
        var rowInvalidateColumnPaths = this.getColumns().filter(function (column) { return _.get(column, "settings.invalidateOnlyRow"); }).map(function (column) { return column.dataPath; });
        var filterRowByOnlyInvalidateColumns = function (row) {
            var mappedRow = {};
            rowInvalidateColumnPaths.forEach(function (path) {
                _.set(mappedRow, path, _.get(row, path));
            });
            return mappedRow;
        };
        var validRows = {};
        if (rows) {
            rows.filter(function (row) { return !row.isInvalidated; }).forEach(function (row) {
                validRows[row.tag] = filterRowByOnlyInvalidateColumns(row);
            });
        }
        return validRows;
    };
    NonPosterDataController.prototype.mergeBackNonInvalidateRows = function (oldRows, newRows) {
        newRows.forEach(function (newRow) {
            if (!newRow.isInvalidated) {
                var correspondingOldRow = oldRows[newRow.tag];
                _.assign(newRow, correspondingOldRow);
            }
        });
    };
    NonPosterDataController.prototype.getGroupFieldsToKeep = function () {
        var fieldsToKeep = GroupFieldFactory_1.GroupFieldFactory.getAllGroupFields().map(function (fieldToKeep) { return fieldToKeep.dataField; });
        var result = [];
        if (!this._table.rows) {
            return result;
        }
        for (var _i = 0, _a = this._table.rows; _i < _a.length; _i++) {
            var row = _a[_i];
            if (!row.isReadOnly) {
                var thisFieldsToKeep = {};
                for (var _b = 0, fieldsToKeep_1 = fieldsToKeep; _b < fieldsToKeep_1.length; _b++) {
                    var fieldToKeep = fieldsToKeep_1[_b];
                    _.set(thisFieldsToKeep, fieldToKeep, _.get(row, fieldToKeep));
                }
                _.set(thisFieldsToKeep, "tag", _.get(row, "tag"));
                result.push(thisFieldsToKeep);
            }
        }
        return result;
    };
    NonPosterDataController.mergeFieldsToKeepToRows = function (newRows, fieldsToKeep) {
        var _loop_1 = function (row) {
            if (!row.isReadOnly) {
                var matchingFieldsToKeep = _.find(fieldsToKeep, function (fieldToKeep) {
                    return fieldToKeep.tag === row.tag;
                });
                _.assign(row, matchingFieldsToKeep);
            }
        };
        for (var _i = 0, newRows_1 = newRows; _i < newRows_1.length; _i++) {
            var row = newRows_1[_i];
            _loop_1(row);
        }
    };
    NonPosterDataController.prototype.setNewPlacementToPlan = function (newPlacement, row) {
        var newPlan = this.setNewPlacementToPlanAndReturnIt(newPlacement, row);
        if (newPlan && !_.isEqual(this._context.plan, newPlan)) {
            this._table.fireInvalidateEvaluationEvent();
            this.setNewPlanWithInvalidation(newPlan);
        }
    };
    NonPosterDataController.prototype.setNewPlacementToPlanAndReturnIt = function (newPlacement, row) {
        var plan = this._context.plan;
        var _a = findPlanElement_1.findPlanElement(plan, row), groupIndex = _a.groupIndex, placementIndex = _a.placementIndex;
        if (groupIndex !== -1 && placementIndex !== -1) {
            var mediumGroups = plan.mediumGroups;
            var mediumGroup = plan.mediumGroups[groupIndex];
            var placements = mediumGroup.mediumGroup;
            var newPlacements = placements.slice();
            newPlacements[placementIndex] = newPlacement;
            var newMediumGroup = _.assign({}, mediumGroup, { mediumGroup: newPlacements });
            var newMediumGroups = mediumGroups.slice();
            newMediumGroups[groupIndex] = newMediumGroup;
            row.isInvalidated = true;
            return _.assign({}, plan, { mediumGroups: newMediumGroups });
        }
        return undefined;
    };
    NonPosterDataController.removeRowFromPlan = function (row, plan) {
        var _a = findPlanElement_1.findPlanElement(plan, row), groupIndex = _a.groupIndex, placementIndex = _a.placementIndex;
        if (groupIndex !== -1) {
            var mediumGroups = plan.mediumGroups;
            var mediumGroup = mediumGroups[groupIndex];
            var placements = mediumGroup.mediumGroup;
            var newPlacements = placements.slice();
            newPlacements.splice(placementIndex !== -1 ? placementIndex : 0, 1);
            var newMediumGroups = mediumGroups.slice();
            if (newPlacements.length === 0) {
                newMediumGroups.splice(groupIndex, 1);
            }
            else {
                newMediumGroups[groupIndex] =
                    _.assign({}, mediumGroup, { mediumGroup: newPlacements });
            }
            plan = _.assign({}, plan, { mediumGroups: newMediumGroups });
        }
        return plan;
    };
    NonPosterDataController.prototype.onRowsRemoved = function (rows) {
        var _this = this;
        this._table.fireInvalidateEvaluationEvent();
        var newPlan = _.cloneDeep(this._context.plan);
        rows.forEach(function (row) {
            newPlan = NonPosterDataController.removeRowFromPlan(row, newPlan);
        });
        this.setNewPlanWithInvalidation(newPlan).then(function () {
            _this.setNewPlan(newPlan);
        });
    };
    NonPosterDataController.prototype.onPlanCleared = function () {
        var plan = this._context.plan;
        plan.mediumGroups = [];
        this.setNewPlan(plan);
    };
    NonPosterDataController.prototype.onRowAdded = function (row) {
        var _this = this;
        this._table.fireInvalidateEvaluationEvent();
        this._groupManager.addGroupRow(this._context.plan, this._preset, row, this.getRateCardOptions(this._context)).then(function (newPlan) {
            _this.setNewPlanWithInvalidation(newPlan).then(function () {
                _this.setNewPlan(newPlan);
            });
            _this._table.clearAllSelectedRows();
        });
    };
    NonPosterDataController.prototype.getAllRateCards = function (mediaKeys, options) {
        var promises = [];
        mediaKeys.forEach(function (mediaKey) {
            promises.push(mmxlGetter_1.MmxlGetter.getRateCard(mediaKey, options));
        });
        return Promise.all(promises).then(function (objects) { return _.indexBy(objects, function (object, index) { return mediaKeys[index]; }); });
    };
    NonPosterDataController.getAllCards = function (getter, mediaKeys) {
        return Promise.all(mediaKeys.map(getter))
            .then(function (objects) { return _.indexBy(objects, function (object, index) { return mediaKeys[index]; }); });
    };
    NonPosterDataController.prototype.updatePreset = function (preset) {
        var _this = this;
        var analysisPromise = this._context.analysisPromise;
        var adFormatPromise = this._adFormatController.getStandardAdFormats();
        return Promise.all([analysisPromise, adFormatPromise]).then(function (result) {
            var analysis = result[0];
            var adFormats = result[1];
            if (!_.find(adFormats, { id: "AGOF_Werbeform_0" })) {
                adFormats.unshift(adFormatController_1.AdFormatController.createNullAdformat());
            }
            NonPosterDataController.setPeriodsInColumn(analysis);
            var rateCards = {
                DUMMY_MEDIUM: _.assign({}, DummyRateCard_1.DUMMY_RATE_CARD, { adFormats: adFormats })
            };
            var presetRows = _this.createTableRows([{ mediumGroup: [preset], groupTitle: "" }], rateCards);
            _this._table.presetRow = presetRows[0];
        });
    };
    NonPosterDataController.prototype.setNewContext = function (context, addToQueue) {
        if (addToQueue === void 0) { addToQueue = true; }
        if (addToQueue) {
            this._contextQueue.addContext(context);
        }
        this._context = context;
        if (!this._rawSampleController) {
            this._rawSampleController = new rawSampleController_1.RawSampleController(this._table, context.analysisId, this._mmxl);
        }
        if (!this._hasExternalCalcTrigger) {
            return this.triggerCalculation();
        }
        return Promise.resolve();
    };
    NonPosterDataController.prototype.setNewPlan = function (plan) {
        var _this = this;
        var media = [];
        plan.mediumGroups.forEach(function (group) {
            group.mediumGroup.forEach(function (placement) {
                media.push(placement.medium.key);
                if (_.get(placement, "conditions.online.adFormat") === "AGOF_Werbeform_0") {
                    _.set(placement, "additionalData.frequencyCappingFormatted", configuration_1.PlanConfiguration.ERROR_STRING);
                    _.set(placement, "additionalData.frequencyCappingForTotal", undefined);
                }
                if (_this._options.ddfPeriodToMmxlPeriod) {
                    var newPeriod = _this._options.ddfPeriodToMmxlPeriod(_.get(placement, "period"));
                    var ownTitle = _.get(newPeriod, "store.content.ownTitle");
                    _.set(placement, "period.content.ownTitle", ownTitle);
                    _.set(placement, "dates", newPeriod.dates);
                    _.set(placement, "medium.period", newPeriod.average);
                }
                _.set(placement, "medium.tariffConditionId", "OnlineMedium");
                var conditionsToPick = ["calculation", "gross", "year", "vat", "cashDiscount", "agencyCommission", "online"];
                var newConditions = _.pick(placement.conditions, conditionsToPick);
                _.set(placement, "conditions", newConditions);
            });
        });
        var checkPromises = new Array();
        plan.mediumGroups.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                if (!placement.group) {
                    _.set(placement, "group", "");
                }
                discountController_1.DiscountController.setEmptyAdditionalData(placement);
                if (_this._options.type === "top") {
                    checkPromises.push(checkForValidFrequencyCapping_1.checkForValidFrequencyCapping(placement, -1, false, _this.getRateCardOptions(_this._context))
                        .then(function (checkResult) {
                        if (checkResult === true) {
                            var fcForTotalViewValue = _.get(placement, "frequencyCapping.forTotal") !== undefined
                                ? !placement.frequencyCapping.forTotal
                                : false;
                            var fcImpressionsViewValue = _.get(placement, "frequencyCapping.impressions") !== undefined
                                ? placement.frequencyCapping.impressions
                                : 0;
                            _.set(placement, "additionalData.frequencyCappingForTotal", fcForTotalViewValue);
                            _.set(placement, "additionalData.frequencyCappingFormatted", fcImpressionsViewValue);
                        }
                        else {
                            _.set(placement, "additionalData.frequencyCappingFormatted", configuration_1.PlanConfiguration.ERROR_STRING);
                            _.set(placement, "additionalData.frequencyCappingForTotal", undefined);
                            delete placement.frequencyCapping;
                        }
                    }));
                    if (placement.targeting) {
                        checkPromises.push(_this.getAllowedTargetingKeys(placement, placement.targeting.keys, false)
                            .then(function (allowedTargetingKeys) {
                            placement.targeting = {
                                keys: allowedTargetingKeys,
                                wastage: placement.targeting.wastage,
                                shortCaption: _this._treeManager.getShortDescriptions(allowedTargetingKeys),
                                longCaption: _this._treeManager.getLongDescriptions(allowedTargetingKeys)
                            };
                        }));
                    }
                }
            });
        });
        return Promise.all(checkPromises).then(function () {
            var groupField = _.get(_this._groupField, "dataField");
            var mediumGroupManager = new MediumGroupManager_1.MediumGroupManager(plan.mediumGroups, groupField);
            if (_this._options.isDdf) {
                plan.dates = DdfPeriodController_1.DdfPeriodController.calculateTotalPeriod(plan);
            }
            return _this.setNewContext(_.assign({}, _this._context, {
                plan: plan,
                planToShow: { mediumGroups: mediumGroupManager.mediumGroups, groupField: _this._groupField }
            }));
        });
    };
    NonPosterDataController.generatePlanToSendOut = function (input) {
        var planToSendOut = _.cloneDeep(input);
        planToSendOut.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup.forEach(function (placement) {
                placement.conditions = new NewConditionsAdapter_1.NewConditionsAdapter(placement.conditions);
            });
        });
        return NonPosterDataController.filterPlacementsWithoutPiShare(planToSendOut);
    };
    NonPosterDataController.filterPlacementsWithoutPiShare = function (input) {
        input.forEach(function (mediumGroup) {
            mediumGroup.mediumGroup = mediumGroup.mediumGroup.filter(function (placement) {
                return NonPosterDataController.placementHasPiOrShare(placement);
            });
        });
        return input;
    };
    NonPosterDataController.placementHasPiOrShare = function (placement) {
        return placement && ((placement.pi && placement.pi > 0) || (placement.share && placement.share > 0));
    };
    NonPosterDataController.prototype.updateTable = function (context, scrollToBottom) {
        var _this = this;
        if (scrollToBottom === void 0) { scrollToBottom = false; }
        return this.makeTableData(context).then(function (planRows) {
            return _this._rawSampleController.updateRawSample(context, _this._options.isDdf).then(function () {
                return _this._marketerNames.update(context, _this._context, planRows).then(function (planRowsWithMarketer) {
                    return _this.updateExtraCosts(context, planRowsWithMarketer).then(function (planRowsFull) {
                        var theRows = _this.groupRows(planRowsFull);
                        _this._table.rows = theRows;
                        _this._table.setCheckboxState(theRows, "additionalData.frequencyCappingFormatted", "additionalData.frequencyCappingForTotal");
                        var contextString = JSON.stringify(context);
                        if (contextString !== _this._lastContext) {
                            _this._lastContext = contextString;
                            return _this.startCalculatePlan(context, scrollToBottom);
                        }
                        return Promise.resolve();
                    });
                });
            });
        });
    };
    NonPosterDataController.prototype.groupRows = function (rows) {
        return this._groupManager.groupByGroupField(rows, this._table.allColumns, this._groupField);
    };
    NonPosterDataController.prototype.getSubPlans = function () {
        var _this = this;
        if (!this._table.rows) {
            return [];
        }
        var subPlans = [];
        var subPlan = { mediumGroups: [{ mediumGroup: [], groupTitle: Math.random().toString() }] };
        this._table.rows.forEach(function (row, index) {
            if (index > 0) {
                var placement = _.get(row, "_placement");
                var groupCaption = _.get(row, "groupCaption").toString();
                if (placement && (_.startsWith(groupCaption, "Belegung") || _this._groupField)) {
                    subPlan.mediumGroups[0].mediumGroup.push(placement);
                }
                else {
                    subPlans.push(subPlan);
                    subPlan = { mediumGroups: [{ mediumGroup: [], groupTitle: Math.random().toString() }] };
                }
            }
        });
        subPlans.push(subPlan);
        return subPlans;
    };
    NonPosterDataController.prototype.getGroupSumRows = function () {
        var _this = this;
        var subPlans = this.getSubPlans();
        var subMmxlPlans = [];
        subPlans.forEach(function (plan) {
            var newPlan = NonPosterDataController.makeMmxlPlan({
                plan: plan,
                dates: _this._context.plan.dates,
                prefilter: _this._context.prefilter,
                audience: _this._context.audience,
                conditions: _this._context.conditions
            });
            newPlan.plan["type"] = "PLAN";
            if (NonPosterDataController.isMmxlPlanValid(newPlan) && newPlan.plan.placements.length > 0) {
                subMmxlPlans.push(newPlan);
            }
        });
        var promisesToDo = [];
        var rawSamplesPromises = [];
        subMmxlPlans.forEach(function (subPlan) {
            var promisePlanDetails = _this._mmxl.evalPlanDetails(_this._context.analysisId, subPlan);
            promisesToDo.push(promisePlanDetails);
            rawSamplesPromises.push(_this._rawSampleController.retrieveSingleRawSamplesFromPlan(subPlan.plan, _this._context.plan.dates));
        });
        return Promise.all(promisesToDo).then(function (planDetailsResults) {
            return Promise.all(rawSamplesPromises).then(function (rawSamples) {
                var theRows = _this._table.rows;
                var sumRows = theRows.filter(function (item) {
                    return item.isReadOnly === true;
                });
                planDetailsResults.forEach(function (planDetailsResult, index) {
                    var sumRow = RowResponseMerger_1.RowResponseMerger.mergeResponseResult(sumRows[index], planDetailsResult);
                    _.set(sumRow, "rawSample", rawSamples[index]);
                    var subRows = _this.getSubrows(sumRow);
                    subRows.forEach(function (subRow) {
                        _.set(subRow, "rawSample", rawSamples[index]);
                    });
                    var periodFieldsDisplay = NonPosterDataController._periodFields.length > 0 ? NonPosterDataController._periodFields[0].editor.config.display : [];
                    sumRow = TotalRowController_1.TotalRowController.calcTotalRow(subRows, sumRow, periodFieldsDisplay);
                    _.merge(sumRows[index], sumRow);
                });
                _this._table.rows = _.merge(_this._table.rows, theRows);
            });
        });
    };
    NonPosterDataController.prototype.getSubrows = function (start) {
        if (this._groupField) {
            var startIndex = _.findIndex(this._table.rows, function (candidate) {
                return candidate.isReadOnly === true && candidate.groupCaption === start.groupCaption;
            });
            var result = [];
            for (var i = startIndex + 1; i < this._table.rows.length; i++) {
                var currentRow = this._table.rows[i];
                if (!currentRow.isReadOnly) {
                    result.push(currentRow);
                }
                else {
                    break;
                }
            }
            return result;
        }
        else {
            var placements = _.get(start, "_group.mediumGroup");
            if (!placements) {
                return [];
            }
            var tags_1 = placements.map(function (placement) { return placement.tag; });
            var result = this._table.rows.filter(function (row) {
                var tag = _.get(row, "tag");
                return tags_1.indexOf(tag) > -1;
            });
            return result;
        }
    };
    NonPosterDataController.prototype.startCalculatePlan = function (context, scrollToBottom) {
        var _this = this;
        if (scrollToBottom === void 0) { scrollToBottom = false; }
        return this.calculatePlan(context)
            .then(function () {
            _this.completeCalculatePlan(context);
            _this.getGroupSumRows().then(function () {
                if (scrollToBottom) {
                    _this._table.scrollToBottom();
                }
            });
        })
            .catch(function (error) {
            configuration_1.PlanConfiguration.logger.error("ERROR: failed to calculate plan: " + error.message);
            configuration_1.PlanConfiguration.logger.error(error);
            _this.completeCalculatePlan(context);
        });
    };
    NonPosterDataController.prototype.completeCalculatePlan = function (context) {
        if (this._context !== context) {
            this.startCalculatePlan(this._context);
        }
    };
    NonPosterDataController.isMmxlPlanValid = function (mmxlPlan) {
        if (!mmxlPlan.dates) {
            return false;
        }
        if (!mmxlPlan.dates[0].from || !mmxlPlan.dates[0].to) {
            return false;
        }
        return true;
    };
    NonPosterDataController.prototype.calculatePlan = function (context) {
        var _this = this;
        var mmxlPlan = NonPosterDataController.makeMmxlPlan({
            plan: context.plan,
            conditions: context.conditions,
            prefilter: context.prefilter,
            audience: context.audience,
            dates: context.plan.dates
        });
        context.plan.dates = mmxlPlan.dates;
        if (!NonPosterDataController.isMmxlPlanValid(mmxlPlan)) {
            this._contextQueue.clear();
            this._table.setStatusIdle();
            this.sendPlanOut(context.plan);
            return new Promise(function (resolve, reject) {
                resolve();
            });
        }
        this._table.setStatusBusy();
        var promisePlanDetails = this._mmxl.evalPlanDetails(this._context.analysisId, mmxlPlan);
        var promiseAnalysisInfo = context.analysisPromise;
        var promisesToDo = [];
        promisesToDo.push(promisePlanDetails);
        promisesToDo.push(promiseAnalysisInfo);
        if (this._dataMultiplierController) {
            var dataMultiplierPlans = this._dataMultiplierController.generateDataMultiplierPromises(mmxlPlan);
            dataMultiplierPlans.forEach(function (dataMultiplierPlan) {
                promisesToDo.push(_this._mmxl.evalPlanDetails(_this._context.analysisId, dataMultiplierPlan));
            });
        }
        var inContextQueueId = context.queueId;
        return Promise.all(promisesToDo)
            .then(function (results) {
            if ((!_this._contextQueue.isActive && context === _this._context) ||
                (_this._contextQueue.isActive &&
                    (!_this._contextQueue.lastContext ||
                        inContextQueueId === _this._contextQueue.lastContext.queueId))) {
                _this._contextQueue.clear();
                _this._currentContext = _.cloneDeep(context);
                var planDetails = results[0], analysis = results[1];
                var multiplierData = {};
                if (_this._dataMultiplierController) {
                    var resultSliceIndex = 2;
                    var multiplierPlanResults = results.slice(resultSliceIndex);
                    multiplierData
                        = _this._dataMultiplierController.retrieveDataFromMultiplierPlans(multiplierPlanResults, "result.contacts", "timeClasses");
                }
                _this._table.activeMediumTypes = analysis.tariffConditions;
                if (planDetails.groupDetails !== undefined && planDetails.groupDetails.length > 0) {
                    NonPosterDataController.setPeriodsInColumn(analysis);
                    var customGrouping = _this._context.planToShow.groupField !== undefined;
                    _this._table.rows = NonPosterDataController.mergeTableRowsWithResponse(_this._table.rows, planDetails, analysis, customGrouping, _this._treeManager, multiplierData);
                }
                if (_this._table.rows.length > 0) {
                    _this._table.totalRow = RowResponseMerger_1.RowResponseMerger.mergeResponseResult(_this._table.totalRow, planDetails);
                }
                else {
                    _this._table.totalRow = RowResponseMerger_1.RowResponseMerger.mergeResponseResult({}, planDetails);
                }
                var periodDisplay = _.get(NonPosterDataController._periodFields[0], "editor.config.display");
                _this._table.totalRow = TotalRowController_1.TotalRowController.calcTotalRow(_this._table.rows, _this._table.totalRow, periodDisplay, _this._isOnlineApi);
                _this._table.totalRow["groupCaption"] = "Planwerte Gesamt";
                _this.removeInvalidateRowFlags();
                _this._table.setStatusIdle();
                _this.sendPlanOut(context.plan);
            }
        });
    };
    NonPosterDataController.prototype.removeInvalidateRowFlags = function () {
        this._table.rows.forEach(function (row) {
            delete row.isInvalidated;
        });
    };
    NonPosterDataController.prototype.sendPlanOut = function (plan) {
        var groupField = _.get(this._groupField, "dataField");
        var mediumGroupManager = new MediumGroupManager_1.MediumGroupManager(plan.mediumGroups, groupField);
        var planToSendOut = NonPosterDataController.generatePlanToSendOut(mediumGroupManager.mediumGroups);
        this._planChangedEvent.trigger(planToSendOut);
    };
    NonPosterDataController.setPeriodsInColumn = function (analysis) {
        var periodsObject = {};
        if (analysis.periods) {
            analysis.periods.forEach(function (period) {
                periodsObject[period.key] = stringHelper_1.StringHelper.shortenPeriodDescription(period.description);
            });
            this._periodFields.forEach(function (field) {
                field.editor.config.display = periodsObject;
            });
        }
    };
    NonPosterDataController.prototype.updateExtraCosts = function (context, rows) {
        var _this = this;
        return this.getExtraCosts(context.plan.mediumGroups, this.getRateCardOptions(context))
            .then(function (costs) {
            if (context === _this._context) {
                var chargeRows_1 = [];
                var index_1 = 0;
                rows.forEach(function (row) {
                    if (_.get(row, "conditions.online.adFormat")) {
                        chargeRows_1.push(costs[index_1++]);
                    }
                    else {
                        chargeRows_1.push({});
                    }
                });
                return rows.map(function (row, i) { return _.assign({}, row, chargeRows_1[i]); });
            }
            else {
                return rows;
            }
        });
    };
    NonPosterDataController.prototype.getExtraCosts = function (mediumGroups, rateCardOptions) {
        var _this = this;
        return Promise.all(flattenPlacements_1.flattenPlacements(mediumGroups)
            .map(function (placement) {
            return mmxlGetter_1.MmxlGetter.getRateCard(placement.medium.key, rateCardOptions)
                .then(function (rateCard) {
                if (!rateCard) {
                    return;
                }
                var adFormat = _.get(placement, "conditions.online.adFormat");
                var promisesToDo = new Array();
                if (rateCard.frequencyCapping && _this._isOnlineApi) {
                    promisesToDo.push(mmxlGetter_1.MmxlGetter.getFrequencyCappingKits(rateCard.frequencyCapping)
                        .then(function (frequencyCappingKits) {
                        return ({
                            frequencyCappingCost: chargeController_1.ChargeController.calculateCharge(adFormat, placement.medium.period, frequencyCappingKits, placement.frequencyCapping !== undefined)
                        });
                    }));
                }
                if (rateCard.targeting && _this._isOnlineApi) {
                    promisesToDo.push(mmxlGetter_1.MmxlGetter.getTargetingKits(rateCard.targeting)
                        .then(function (targetingKits) {
                        return ({
                            targetingCost: chargeController_1.ChargeController.calculateCharge(adFormat, placement.medium.period, targetingKits, placement.targeting !== undefined)
                        });
                    }));
                }
                return Promise.all(promisesToDo).then(function (charges) {
                    return charges.reduce(function (previous, current) { return _.assign(previous, current); }, {});
                });
            });
        }));
    };
    NonPosterDataController._periodFields = new Array();
    return NonPosterDataController;
}());
exports.NonPosterDataController = NonPosterDataController;
//# sourceMappingURL=nonPosterDataController.js.map


//////////////////
// WEBPACK FOOTER
// ./buildForProduction/datalayer/nonPosterDataController.js
// module id = 11
// module chunks = 0